import React, { Component } from 'react';
import { Button, Nav, NavItem, NavLink, TabContent, TabPane, Badge, Card, Toast, ToastBody, CardBody, Spinner, CardHeader, Col, FormGroup, Input, Label, Row } from 'reactstrap';
//import Loader from '../Loader.js';
import { TimePicker } from 'antd';
import 'antd/dist/antd.css';
import moment from 'moment';

import Nouislider from "nouislider-react";
import "nouislider/distribute/nouislider.css";

import ExportDeviceSettingsMobileStarterBatch from './ExportDeviceSettingsMobileStarterBatch.js';
const format = 'HH:mm';

class ExportDeviceSettingsMobileStarter extends Component {

  constructor(props) {
    super(props);
    this.state = {
      activeTab: '1',
      currentPageTabId: '',
    }
  }

  componentDidMount() {
    this.fetchDisplayStatusDetails();
  }


  toggle(tab) {
    this.setState({
      activeTab: tab,
    });
  }

  handleCheckboxChangeforce_immediate = (event) => {
    //console.log("test")
    this.props.handleCheckboxChangeforce_immediate(event, this.props.index);
  }

  handleMotorType = (event) => {
    this.props.handleMotorType(event, this.props.index);
  }

  handleValveBrand = (event) => {
    this.props.handleValveBrand(event, this.props.index);
  }

  handleStartDelay = (event) => {
    this.props.handleStartDelay(event, this.props.index);
  }

  handleStopDelay = (event) => {
    this.props.handleStopDelay(event, this.props.index);
  }

  handlel12_l = (event) => {
    this.props.handlel12_l(event, this.props.index);
  }

  handlel12_h = (event) => {
    this.props.handlel12_h(event, this.props.index);
  }

  handlel23_l = (event) => {
    this.props.handlel23_l(event, this.props.index);
  }
  handlel23_h = (event) => {
    this.props.handlel23_h(event, this.props.index);
  }


  handlel31_l = (event) => {
    this.props.handlel31_l(event, this.props.index);
  }
  handlel31_h = (event) => {
    this.props.handlel31_h(event, this.props.index);
  }


  handlelc_l = (event) => {
    this.props.handlelc_l(event, this.props.index);
  }
  handlelc_h = (event) => {
    this.props.handlelc_h(event, this.props.index);
  }




  btnSubmit = (e) => {
    this.props.btnSubmit(this.props.index);
  }




  onTimeChangeStartSun = (time, timeString, day) => {
    // console.log(time);
    // console.log(timeString);
    this.props.onTimeChangeStartSun(time, timeString, this.props.index, day);

  }
  onTimeChangeStopSun = (time, timeString, day) => {
    // console.log(time);
    // console.log(timeString);
    this.props.onTimeChangeStopSun(time, timeString, this.props.index, day);

  }

  handleChange_copyfrom = (event, day) => {
    this.props.handleChange_copyfrom(event, this.props.index, day);
  }

  handleChange_ops_mode_sun = (event, day) => {
    this.props.handleChange_ops_mode_sun(event, this.props.index, day);
  }

  handleChange_noofcycles_sun = (event, day) => {
    this.props.handleChange_noofcycles_sun(event, this.props.index, day);
  }

  handleCyclegapChangeSun = (event, day) => {
    this.props.handleCyclegapChangeSun(event, this.props.index, day);
  }

  handleUpdateSunBatch = (updatedCards, index, day) => {
    this.props.handleUpdateSunBatch(updatedCards, index, day)
  }

  renderConfigTab = () => {
    // Add the config-specific content here
    return (
      <>
        <Row>
          <Col md="6">
            <FormGroup>
              <Label htmlFor="nf-1">Motor Type</Label>
              <Input type="select" disabled={this.props.disabled} name="motor_type" id="motor_type" value={this.props.data.config ? this.props.data.config.settings.pump_type : ""}
                onChange={this.handleMotorType}
              >
                <option value="">Select</option>
                <option value="1">Starter Type 1</option>
                <option value="2">Starter Type 2</option>
                <option value="3">Non Starter</option>
                {this.props.data.exp_device_type === 72 && (
                  <option value="4">Solor</option>
                )}
              </Input>
              <div style={{ color: "red", marginTop: 4 }}>{this.state.displayErrorMessageForMotorType}</div>

            </FormGroup>
          </Col>
          {this.props.data.exp_device_type === 72 && (
            <Col md="6">
              <FormGroup>
                <Label htmlFor="nf-1">Valve</Label>
                <Input type="select" disabled={this.props.disabled} name="valve_brand" id="valve_brand" value={this.props.data.config ? this.props.data.config.settings.valve_brand : ""}
                  onChange={this.handleValveBrand}
                >
                  <option value="">Select</option>
                  <option value="1">Bacarra</option>
                </Input>
                <div style={{ color: "red", marginTop: 4 }}>{this.state.displayErrorMessageForMotorType}</div>

              </FormGroup>
            </Col>
          )}
        </Row>
        {this.props.data.config ?
          <>
            <Row>
              <Col md="6">
                <FormGroup>
                  <Label htmlFor="nf-1">Start Delay  [MS]</Label>
                  <Input type="number" disabled={
                    this.props.disabled ? this.props.disabled :
                      (this.props.data.config.settings.pump_type == 1
                        || this.props.data.config.settings.pump_type == 2) ? false
                        : true} id="nf-crop-name" name="nf-crop-name" placeholder={"Start Delay in Seconds"} onChange={this.handleStartDelay}
                    value={this.props.data.config ? this.props.data.config.settings.start_delay : ""} />
                  <div style={{ color: "red", marginTop: 4 }}>{this.state.displayErrorMessageForStartDelay}</div>
                </FormGroup>
              </Col>
              <Col md="6">
                <FormGroup>
                  <Label htmlFor="nf-1">Stop Delay  [MS]</Label>
                  <Input type="number" disabled={
                    this.props.disabled ? this.props.disabled :
                      (this.props.data.config.settings.pump_type == 2) ? false
                        : true} id="nf-crop-name" name="nf-crop-name" placeholder={"Stop Delay in Seconds"} onChange={this.handleStopDelay}
                    value={this.props.data.config ? this.props.data.config.settings.stop_delay : ""} />
                  <div style={{ color: "red", marginTop: 4 }}>{this.state.displayErrorMessageForStopDelay}</div>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md="6">
                <FormGroup>
                  <Label htmlFor="nf-1">Voltage 1 Min</Label>
                  <Input type="number" disabled={this.props.disabled}
                    id="nf-crop-name" name="nf-crop-name" placeholder={"Voltage 1 Min"} onChange={this.handlel12_l}
                    value={this.props.data.config ? this.props.data.config.settings.sensing[0].l : "0"} />
                  <div style={{ color: "red", marginTop: 4 }}>{this.state.displayErrorMessageForl12_l}</div>
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup>
                  <Label htmlFor="nf-1">Voltage 1 Max</Label>
                  <Input type="number" disabled={this.props.disabled}
                    id="nf-crop-name" name="nf-crop-name" placeholder={"Voltage 1 Max"} onChange={this.handlel12_h}
                    value={this.props.data.config ? this.props.data.config.settings.sensing[0].h : "0"} />
                  <div style={{ color: "red", marginTop: 4 }}>{this.state.displayErrorMessageForl12_h}</div>
                </FormGroup>
              </Col>
            </Row>
            {this.props.data.config && this.props.data.config.settings.pump_type != "4" ? (
              <>
                <Row>
                  <Col md="6">
                    <FormGroup>
                      <Label htmlFor="nf-1">Voltage 2 Min</Label>
                      <Input
                        type="number"
                        maxLength="3"
                        disabled={this.props.disabled}
                        id="nf-crop-name"
                        name="nf-crop-name"
                        placeholder="Voltage 2 Min"
                        onChange={this.handlel23_l}
                        value={
                          this.props.data.config
                            ? this.props.data.config.settings.sensing[1].l
                            : "0"
                        }
                      />
                      <div style={{ color: "red", marginTop: 4 }}>
                        {this.state.displayErrorMessageForl23_l}
                      </div>
                    </FormGroup>
                  </Col>

                  <Col md="6">
                    <FormGroup>
                      <Label htmlFor="nf-1">Voltage 2 Max</Label>
                      <Input
                        type="number"
                        maxLength="3"
                        disabled={this.props.disabled}
                        id="nf-crop-name"
                        name="nf-crop-name"
                        placeholder="Voltage 2 Max"
                        onChange={this.handlel23_h}
                        value={
                          this.props.data.config
                            ? this.props.data.config.settings.sensing[1].h
                            : "0"
                        }
                      />
                      <div style={{ color: "red", marginTop: 4 }}>
                        {this.state.displayErrorMessageForl23_h}
                      </div>
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md="6">
                    <FormGroup>
                      <Label htmlFor="nf-1">Voltage 3 Min</Label>
                      <Input
                        type="number"
                        maxLength="3"
                        disabled={this.props.disabled}
                        id="nf-crop-name"
                        name="nf-crop-name"
                        placeholder="Voltage 3 Min"
                        onChange={this.handlel31_l}
                        value={
                          this.props.data.config
                            ? this.props.data.config.settings.sensing[2].l
                            : "0"
                        }
                      />
                      <div style={{ color: "red", marginTop: 4 }}>
                        {this.state.displayErrorMessageForl31_l}
                      </div>
                    </FormGroup>
                  </Col>

                  <Col md="6">
                    <FormGroup>
                      <Label htmlFor="nf-1">Voltage 3 Max</Label>
                      <Input
                        type="number"
                        maxLength="3"
                        disabled={this.props.disabled}
                        id="nf-crop-name"
                        name="nf-crop-name"
                        placeholder="Voltage 3 Max"
                        onChange={this.handlel31_h}
                        value={
                          this.props.data.config
                            ? this.props.data.config.settings.sensing[2].h
                            : "0"
                        }
                      />
                      <div style={{ color: "red", marginTop: 4 }}>
                        {this.state.displayErrorMessageForl31_h}
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
              </>
            ) : (
              <></>
            )}



            <Row>
              <Col md="6">
                <FormGroup>
                  <Label htmlFor="nf-1">{"Current in Amps Min"}</Label>
                  <Input type="number" disabled={this.props.disabled}
                    id="nf-crop-name" name="nf-crop-name" placeholder={"Current in Amps Min"} onChange={this.handlelc_l}
                    value={this.props.data.config ? this.props.data.config.settings.sensing[3].l : "0"} />
                  <div style={{ color: "red", marginTop: 4 }}>{this.state.displayErrorMessageForl31_l}</div>
                </FormGroup>
              </Col>

              <Col md="6">
                <FormGroup>
                  <Label htmlFor="nf-1">{"Current in Amps Max"}</Label>
                  <Input type="number" disabled={this.props.disabled}
                    id="nf-crop-name" name="nf-crop-name" placeholder={"Current in Amps Max"} onChange={this.handlelc_h}
                    value={this.props.data.config ? this.props.data.config.settings.sensing[3].h : "0"} />
                  <div style={{ color: "red", marginTop: 4 }}>{this.state.displayErrorMessageForl31_h}</div>
                </FormGroup>
              </Col>
            </Row>

          </>
          : null}

      </>

    );
  }

  renderDaySettings = (day) => {
    const hours = Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0'));
    const minutes = Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, '0'));
    return (
      <>

        {this.props.data.config ?
          <>
            <Row>
              <Col xs="8" md="8"></Col>
              <Col xs="4" md="4">
                <FormGroup>
                  <Label htmlFor="select">Copy</Label>
                  <Input type="select" name="selectRS485" id="selectRS485"
                    value={this.props.data.config.schedule[day].copy_from}
                    onChange={(event) => this.handleChange_copyfrom(event, day)}
                  >
                    <option value="0"></option>
                    <option value="1">Sunday</option>
                    <option value="2">Monday</option>
                    <option value="3">Tuesday</option>
                    <option value="4">Wednesday</option>
                    <option value="5">Thursday</option>
                    <option value="6">Friday</option>
                    <option value="7">Saturday</option>
                  </Input>
                </FormGroup>
              </Col>
            </Row>
            <Row>

              <Col xs="12" md="6">
                <FormGroup>
                  <Label htmlFor="select">Automation Window</Label>
                  <Row>
                    <Col xs="6" md="6">
                      <TimePicker
                        value={this.props.data.config.schedule[day].start_time != null ? moment(this.props.data.config.schedule[day].start_time, format) : this.props.data.config.schedule[day].start_time}
                        format={format}
                        onChange={(time, timeString) => this.onTimeChangeStartSun(time, timeString, day)}
                        size="large" />
                    </Col>
                    <Col xs="6" md="6">
                      <TimePicker
                        value={this.props.data.config.schedule[day].stop_time != null ? moment(this.props.data.config.schedule[day].stop_time, format) : this.props.data.config.schedule[day].stop_time}
                        format={format}
                        onChange={(time, timeString) => this.onTimeChangeStopSun(time, timeString, day)}
                        size="large" />
                    </Col>
                  </Row>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="12" md="6">
                <FormGroup>
                  <Label htmlFor="select">Operation Mode</Label>
                  <Input type="select" name="selectRS485" id="selectRS485"
                    value={this.props.data.config.schedule[day].automation}
                    onChange={(event) => this.handleChange_ops_mode_sun(event, day)}
                  >
                    <option value="1">Duration Based</option>
                    <option value="2">Time Based</option>
                  </Input>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col xs="12" md="6">
                <FormGroup>
                  <Card>
                    <CardBody>
                      <ExportDeviceSettingsMobileStarterBatch
                        details={this.props.data.config.schedule[day]}
                        index={this.props.index}
                        handleUpdateSunBatch={this.handleUpdateSunBatch}
                        day={day}
                      />
                    </CardBody>
                  </Card>
                </FormGroup>
              </Col>
            </Row>
            {this.props.data.config.schedule[day].automation == 1 ?
              <>
                <Row>
                  <Col xs="12" md="6">
                    <FormGroup>
                      <Label htmlFor="select">Number of Cycles</Label>
                      <Input type="select" name="selectRS485" id="selectRS485"
                        value={this.props.data.config.schedule[day].no_of_cycles}
                        onChange={(event) => this.handleChange_noofcycles_sun(event, day)}
                      >
                        <option value={1}>1</option>
                        <option value={2}>2</option>
                        <option value={3}>3</option>
                        <option value={4}>4</option>
                        <option value={5}>5</option>
                        <option value={6}>6</option>
                      </Input>
                    </FormGroup>
                  </Col>
                </Row>
                {this.props.data.config.schedule[day].no_of_cycles > 1 ?
                  <Row>
                    <Col xs="12" md="6">
                      <FormGroup>
                        <Label htmlFor="select">Cycle gap</Label>
                        <Input
                          type="number"
                          placeholder="Enter Minutes"
                          value={this.props.data.config.schedule[day].cycle_gap_minute}
                          onChange={(event) => this.handleCyclegapChangeSun(event, day)}
                        />
                      </FormGroup>
                    </Col>
                  </Row> : null
                }

              </>
              : <></>
            }

          </>
          : null}


      </>
    );
  }

  fetchDisplayStatusDetails = () => {
    this.setState({
      activeTab: "1",
    })
  }

  render() {
    const days = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
    return (
      <CardBody>
        <Nav tabs>
          <NavItem>
            <NavLink
              active={this.state.activeTab === '1'}
              onClick={() => { this.toggle('1'); }}
            >
              <span className={this.state.activeTab === '1' ? '' : 'd-none'}> </span>
              &nbsp;&nbsp;<Badge color="info">Config</Badge>
            </NavLink>
          </NavItem>
          {days.map((day, index) => (
            <NavItem key={index + 2}>
              <NavLink
                active={this.state.activeTab === String(index + 2)}
                onClick={() => { this.toggle(String(index + 2)); }}
              >
                <span className={this.state.activeTab === String(index + 2) ? '' : 'd-none'}> </span>
                &nbsp;&nbsp;<Badge color="info">{day.charAt(0).toUpperCase() + day.slice(1)}</Badge>
              </NavLink>
            </NavItem>
          ))}



        </Nav>
        <TabContent activeTab={this.state.activeTab}>
          {/* Config Tab */}
          <TabPane tabId="1">
            {this.renderConfigTab()}
          </TabPane>

          {/* Day Tabs */}
          {days.map((day, index) => (
            <TabPane tabId={String(index + 2)} key={index}>
              {this.renderDaySettings(day)}
            </TabPane>
          ))}
        </TabContent>
        <Row>
          <Col md="6">
            <FormGroup check className="checkbox" >
              <Input className="form-check-input" type="checkbox"
                checked={this.props.data.config?.force_immediate || false} id="chkforceimd"
                onChange={(event) => this.handleCheckboxChangeforce_immediate(event.target.checked)} />
              <Label check className="form-check-label" htmlFor={"chkforceimd"}>Force Immediate</Label>
            </FormGroup>
          </Col>
        </Row>
        &nbsp;&nbsp;


        <Button color="success" block onClick={this.btnSubmit} disabled={this.props.disabled ? this.props.disabled : this.props.isButtonLoading == true ? true : false}><i className="fa icon-check"></i>&nbsp;&nbsp;Save &nbsp;&nbsp;{this.props.isButtonLoading ? <Spinner size="sm"></Spinner> : ''}</Button><br />

      </CardBody>
    );
  }
}

export default ExportDeviceSettingsMobileStarter